module.exports = __webpack_public_path__ + "static/media/border-center-v.0be08db7.svg";